import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl'
import _get from 'lodash/get';
import { selectPollingInterval } from "@/processes/Settings";
import Card from '@/entities/Card';
import { PayoutsIncomeChart } from '~/shared/Payouts';
import TextBlock from '@/shared/ui/TextBlock';
import { useGetBillingAccQuery } from '@/shared/api/Stats';
import { useMinerAccount } from "@/processes/MinerAccounts";
import { useCryptoFormatter } from '@/processes/PoolStats';

type PayoutsIncomeChartWidgetProps = {
  className: string;
}

const PayoutsIncomeChartWidget = (props: PayoutsIncomeChartWidgetProps) => {
  const { className } = props;
  const intl = useIntl();
  const pollingInterval = useSelector(selectPollingInterval);
  const { miner, coin } = useMinerAccount();
  const { formatCryptoAmount } = useCryptoFormatter({ coin })

  const {
    data = {},
    isSuccess: isSuccess,
  } = useGetBillingAccQuery({
    miner,
    coin,
  }, { pollingInterval, skip: !(miner && coin) })

  const estDailyEarnings = _get(data, 'expectedReward24H', 0);
  const estWeeklyEarnings = _get(data, 'expectedRewardWeek', 0);

  return (
    <Card
      className={className}
      title={intl.formatMessage({ id: 'payouts.income' })}
    >
      <div className="flex my-4 -mx-4">
        <TextBlock
          isLoading={!isSuccess}
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'stats.est.earnings' })}
          value={formatCryptoAmount(estDailyEarnings)}
          subValue={coin}
        />
        <TextBlock
          isLoading={!isSuccess}
          rootClassName='mx-4'
          title={intl.formatMessage({ id: 'stats.est.week.earnings' })}
          value={formatCryptoAmount(estWeeklyEarnings)}
          subValue={coin}
        />
      </div>
      <PayoutsIncomeChart/>
    </Card>
  );
}

export default PayoutsIncomeChartWidget;
